<template>
  <div class="page">
    <div class="p16">电子套餐</div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header">
            <div class="flex-row">
              <!-- <el-select v-model="query.timeType" @change="selectChange" class="mr10" placeholder="距离过期时间">
                <el-option v-for="(item, index) in option1" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
              <el-select v-model="query.leftCount" @change="selectCount" placeholder="剩余次数">
                <el-option v-for="(item, index) in option2" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select> -->
              <span style="cursor: pointer;" @click="openDialog">筛选 <i class="el-icon-arrow-down"></i></span>
            </div>
            <div class="align-items">
              <div class="ml20 labelNum">套餐总数：<span>{{ totals.cardCount }}</span></div>
              <div class="ml20 labelNum">剩余次数：<span>{{ totals.leftCount ? totals.leftCount : '0' }}</span></div>
              <div class="ml20 labelNum">已使用次数：<span>{{ totals.useCount ? totals.useCount : '0' }}</span></div>
            </div>
            <!-- <el-button type="primary" @click="rulesMobile" style="height: 48px;">搜索</el-button>
            <el-button type="primary" class="small-btn" @click="addClick()" style="height: 48px;">新增</el-button> -->
          </div>
          <div class="plr16" v-perm="{ key: 'electronPackage', value: 'electronPackage:list' }">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column :align="item.align" :label="item.label" :width="item.width" :min-width="item.minWidth"
                :show-overflow-tooltip="false" v-for="(item, index) in columns" :key="index">
                <template slot-scope="scope">
                  <div v-if="index == 'validDay'">{{ scope.row.validDay == '-1' ? '永久有效' : scope.row.validDay == 0 ? "已过期"
                    :
                    scope.row.validDay }}</div>
                  <div v-else-if="index == 'validEndTime'">{{ scope.row.validDay == '-1' ? '' :
                    formatDate(scope.row.validEndTime) }}</div>
                  <div v-else>{{ Boolean(item.formatDay) ? formatDate(scope.row[index]) : scope.row[index] }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-link type="primary" class="ml10"
                    v-perm="{ key: 'electronPackage', value: 'electronPackage:detail' }"
                    @click="detailPage(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>

        </div>
      </div>
    </div>
    <el-dialog title="筛选" :visible.sync="centerDialogVisible" width="50%" center @close="closeDialog">
      <div class="form-box">
        <div class="form-box-item flex mb-20">
          <span class="label">套餐名称</span>
          <el-input v-model="query.keyword" style="width: 250px;" placeholder="请输入套餐卡名称" size="mini" />
        </div>
        <div class="form-box-item flex">
          <span class="label">距离过期时间</span>
          <div class="flex label-content">
            <span v-for="item, idx in  gqTime" @click="checkCurrent('time', idx, item)" :key="idx"
              :class="{ 'active': currentIndex1 == idx }">
              {{ item.label }}
            </span>
          </div>
        </div>
        <div class="form-box-item flex mb-20" v-if="showDay">
          <span class="label"></span>
          <div class="flex label-content">
            <el-input v-model="query.day" style="width: 100px;" placeholder="请输入" size="mini"
              @input="checkInput('timeType')" />
            <span style="background: transparent;">天内</span>
          </div>
        </div>
        <div class="form-box-item flex">
          <span class="label">剩余次数</span>
          <div class="flex label-content">
            <span v-for="item, idx in syCount " @click="checkCurrent('count', idx, item)" :key="idx"
              :class="{ 'active': currentIndex2 == idx }">
              {{ item.label }}
            </span>
          </div>
        </div>
        <div class="form-box-item flex" v-if="showCount">
          <span class="label"></span>
          <div class="flex label-content">
            <span style="background: transparent;padding: 5px 0;">小于</span>
            <el-input v-model="query.leftCount" style="width: 100px;" placeholder="请输入" size="mini"
              @input="checkInput('leftCount')" />
            <span style="background: transparent;">次</span>
          </div>
        </div>
      </div>
      <div class="btn-group">
        <el-button size="small" @click="reset">重置</el-button>
        <el-button size="small" type="primary" @click="save">确定</el-button>
      </div>
    </el-dialog>
    <!-- <edit-set ref="editSetForm" @change="editChange"></edit-set> -->
    <detail-set ref="detailSetForm"></detail-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
// import editSet from "./edit";
import detailSet from "./detail";
export default {
  mixins: [minxin],
  data() {
    return {
      columns: config.columns,
      list: [],
      option1: [
        { value: '', label: '所有' },
        { value: '1', label: '一个月以内' },
        { value: '2', label: '两个月以内' },
        { value: '3', label: '三个月以内' },
        { value: '4', label: '已过期' },
      ],
      option2: [
        { value: '', label: '所有' },
        { value: '3', label: '小于3次' },
        { value: '6', label: '小于6次' },
      ],
      url: this.$url.packageManagement.list,
      query: {
        keyword: '',
        timeType: '',
        day: '',
        leftCount: '',
        start: 1
      },
      height: this.$store.getters.MainHeight,
      totals: {},
      centerDialogVisible: false,
      gqTime: [
        { value: '', label: '不限' },
        { value: '1', label: '3天内' },
        { value: '2', label: '7天内' },
        { value: '3', label: '一个月内' },
        { value: '4', label: '两个月内' },
        { value: '5', label: '已过期' },
        { value: '', label: '自定义', id: 'self' },
      ],
      syCount: [
        { value: '', label: '不限' },
        { value: '3', label: '小于3次' },
        { value: '6', label: '小于6次' },
        { value: '', label: '自定义', id: 'self' },
      ],
      currentIndex1: 0,
      currentIndex2: 0,
      showDay: false,
      showCount: false
    };
  },
  components: {
    // editSet,
    detailSet
  },
  created() {
    this.totalCounts();
    this.getTotal();
  },
  mounted() {
    this.totalCounts();
    this.getTotal();
  },
  methods: {
    getTotal() {
      this.$api.post(this.$url.packageManagement.sumData, this.query).then(res => {
        console.log(res)
        this.totals = res
      })
    },
    selectChange(org) {
      this.query.start = 1;
      this.query.timeType = org;
      console.log(this.query.timeType);
      this.totalCounts();
      this.getTotal();
    },
    selectCount(org) {
      this.query.start = 1;
      this.query.leftCount = org;
      this.totalCounts();
      this.getTotal();
    },
    back() {
      this.$router.push("/dataList");
    },
    addClick(item) {
      item == undefined
        ? this.$refs["editSetForm"].$emit("set", null)
        : this.$refs["editSetForm"].$emit("set", item);
    },
    rulesMobile() {
      if (this.mobile != "") {
        this.list = [];
        this.start = 1;
        this.totalCounts();

      }
    },
    removeDoQuery() {
      this.query = {
        mobile: "",
        start: 1,
        size: 20
      };
      this.totalCounts();
    },
    totalCounts() {
      this.$api.post(this.$url.packageManagement.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
    editChange(bool) {
      if (bool) {
        this.query = {
          mobile: "",
          start: 1,
          size: 20
        };
        this.totalCounts();
      }
    },
    detailPage(item) {
      this.$refs["detailSetForm"].$emit("set", item);
    },
    checkCurrent(type, idx, item) {
      if (type == 'time') {
        this.currentIndex1 = idx
        this.query.timeType = item.value
        this.query.day = ''
        if (idx == this.gqTime.length - 1) {
          this.showDay = true
          this.query.day = ''
        } else {
          this.showDay = false
        }
      } else {
        this.currentIndex2 = idx
        this.query.leftCount = item.value
        if (idx == this.syCount.length - 1) {
          this.showCount = true
        } else {
          this.showCount = false
        }
      }
    },
    save() {
      this.query.start = 1;
      // this.totalCounts();
      // this.getTotal();
      this.centerDialogVisible = false
    },
    openDialog() {
      this.centerDialogVisible = true
      this.reset()
    },
    closeDialog() {
      this.totalCounts();
      this.getTotal();
    },
    reset() {
      this.currentIndex1 = 0
      this.currentIndex2 = 0
      this.showDay = false
      this.showCount = false
      this.query.keyword = ''
      this.query.timeType = ''
      this.query.leftCount = ''
      this.query.day = ''
    },
    // input校验
    checkInput(option) {
      if (option == 'timeType') {
        this.query.timeType = this.query.timeType.replace(/[^\d]/g, '')
        if (this.query.timeType.length > 6) {
          this.query.timeType = this.query.timeType.substring(0, this.query.timeType.length - 1)
        }
      } else {
        this.query.leftCount = this.query.leftCount.replace(/[^\d]/g, '')
        if (this.query.leftCount.length > 2) {
          this.query.leftCount = this.query.leftCount.substring(0, this.query.leftCount.length - 1)
        }
      }
    },
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";

.page-head {
  height: 100%;
}

.mains-content {
  .member-content-box {
    background-color: #fff;

    .member-header {
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .labelNum {
    text-align: right;
    font-weight: 700;
    margin-right: 50px;
  }
}

.flex {
  display: flex;
}

.form-box {
  .form-box-item {
    // margin-bottom: 20px;

    .label {
      margin-right: 10px;
      color: #000;
      font-weight: bold;
      width: 100px;
    }

    .label-content {
      flex-wrap: wrap;

      span {
        // width: 13%;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background-color: #f2f2f2;
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 5px 10px;
        cursor: pointer;
      }
    }
  }
}

.btn-group {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.active {
  background-color: #e4f2fd;
  color: #226bf6;
}

.mb-20 {
  margin-bottom: 20px;
}
</style>